import { ApiError, DiscoverResult } from "@/types";
import { AxiosRequestConfig } from "axios";
import { fetchData } from "@/utils";

type SearchApiResponse = {
  data: DiscoverResult
  error: ApiError | null;
};

export const searchAi = async (
  accessToken: string,
  searchTerm: string
): Promise<SearchApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/ai/audience/search`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data: { query: searchTerm },
  };

  return fetchData(config);
};
